<script>
export default {
    name: "GatePassPrint",

    data() {

        return {
            patient: {},
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchGatePass(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchGatePass() {
            let url = `Morgue/MorgueGatePass`;
                url += `?PatientID=${this.$route.query.PatientID}`;
                url += `&DischargeId=${this.$route.query.DischargeId}`;

            return this.$http.post(url).then(response => {
                let dischargeDetails = response.data.dischargeDetails;
                this.patient = dischargeDetails.length ? dischargeDetails[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap mx-2">
        <tail-address-header></tail-address-header>
        <div class="w-full p-1 text-center my-3">
            <h5 class="font-medium text-base uppercase">Morgue Gate Pass</h5> 
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base uppercase">Name: {{ patient.patient}}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base uppercase">MRN: {{ patient.patientID }}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Morque No: {{ patient.morgueNo }}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">National Id: {{ patient.nationalid }}</h5>
            </div>
             
        </div> 
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Date Admitted: {{ patient.dateAdmitted | dateFormat }}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Date Discharged: {{ patient.dischargeDate | dateFormat }}</h5>
            </div> <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Days: {{ patient.days }}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Package: {{ patient.package }}</h5>
            </div>
             
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
           
             
                <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Death Cert: {{ patient.deathCertNo|'-' }}</h5> 
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Burial Permit: {{ patient.burialPermit|'-' }}</h5>
            </div> 
        </div>
         <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Brought By: {{ patient.broughtBy|'-'}}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Brought By Relationship: {{ patient.broughtByRelationship|'-' }}</h5>
            </div> <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Brought By ID: {{ patient.broughtByIdNo|'-' }}</h5>
            </div>
            
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Place of Death: {{ patient.placeOfDeath|'-' }}</h5>
            </div><div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Burial Place: {{ patient.village|'-' }}</h5>
            </div><div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Location: {{ patient.location|'-' }}</h5>
            </div>
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Subcounty: {{ patient.subcounty|'-'}}</h5>
            </div>
            
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            
            <div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Collected By: {{ patient.collectedBy|'-' }}</h5>
            </div><div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Collected By Id: {{ patient.collectedByIdNo|'-' }}</h5>
            </div><div class="md:w-1/2 sm:w-1/2">
                <h5 class="font-bold text-base">Collected by Tel: {{ patient.collectedByTel|'-' }}</h5>
            </div>   
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            
            <div class="md:w-1/2 sm:w-1/2 mt-4">
                <h5 class="font-bold text-base">Collected By Signature: ___________________</h5>
            </div>
             
        </div>
        <!-- <div class="w-full text-center p-1 mt-3 border-t-2 border-gray-300">
            <h5 class="font-bold text-base uppercase">{{ patient.patient }}</h5>
        </div>
        <div class="w-full text-center p-1">
            <h5 class="font-bold text-base">Admitted On: 
                {{ patient.admittedOn | dateFormat }}</h5>
        </div>
        <div class="w-full text-center p-1">
            <h5 class="font-bold text-base">Discharged On: 
                {{ patient.dischargeDate | dateFormat }}</h5>
        </div> -->
        <!-- <div class="w-full text-center p-1 my-1">
            <h5 class="font-bold text-base uppercase">IP File NO: {{ patient.ipfileno }}</h5>
        </div>
        <div class="w-full text-center p-1 my-1">
            <h5 class="font-bold text-base uppercase">OP File NO: {{ patient.opfileno }}</h5>
        </div>
        <div class="w-full text-center p-1 my-1">
            <h5 class="font-bold text-base uppercase">Morgue NO: {{ patient.morgueNo }}</h5>
        </div>
        <div class="w-full text-center p-1 my-1">
            <h5 class="font-bold text-base uppercase">Package: {{ patient.package }}</h5>
        </div>
        <div class="w-full text-center p-1 my-1">
            <h5 class="font-bold text-base uppercase">Bed: {{ patient.bed }}</h5>
        </div>
        <div class="w-full text-center p-1 my-1">
            <h5 class="font-bold text-base uppercase">Brought By: {{ patient.broughtBy }}</h5>
        </div>
        <div class="w-full text-center p-1 my-1">
            <h5 class="font-bold text-base uppercase">Village: {{ patient.village }}</h5>
        </div>
        <div class="w-full text-center p-1 my-1">
            <h5 class="font-bold text-base uppercase">Admitted By: {{ patient.admittedBy }}</h5>
        </div> -->
    </div>
</template>